export const IconError = ({ style, className }) => {
  return (
    <svg
      style={style}
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path opacity="0.4" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"/>
      <path d="M13.06 12.0001L15.36 9.70011C15.65 9.41011 15.65 8.93011 15.36 8.64011C15.07 8.35011 14.59 8.35011 14.3 8.64011L12 10.9401L9.7 8.64011C9.41 8.35011 8.93 8.35011 8.64 8.64011C8.35 8.93011 8.35 9.41011 8.64 9.70011L10.94 12.0001L8.64 14.3001C8.35 14.5901 8.35 15.0701 8.64 15.3601C8.79 15.5101 8.98 15.5801 9.17 15.5801C9.36 15.5801 9.55 15.5101 9.7 15.3601L12 13.0601L14.3 15.3601C14.45 15.5101 14.64 15.5801 14.83 15.5801C15.02 15.5801 15.21 15.5101 15.36 15.3601C15.65 15.0701 15.65 14.5901 15.36 14.3001L13.06 12.0001Z"/>
    </svg>
  );
};